import SignInForm from "./SignInForm";

const authFormsComponents = {
  SignInForm,
}

export default authFormsComponents